const backgroundStyle = step => {
  let style = {}
  const bgImg =
    step && step.backgroundImage
      ? step.backgroundImage.id
      : step.backgroundImageId

  if (step && step.backgroundColor) {
    style.backgroundColor = step.backgroundColor
  }

  if (bgImg) {
    style.backgroundImage = `url(${process.env.SITE_ASSET_URL}/${bgImg})`
  }
  return style
}
export default backgroundStyle
